import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Courses from './Courses';
import AddCourses from './AddCourses';
import ViewCourse from './ViewCourse';
import EditCourse from './EditCourse';

const ProtectedRoute = ({ element, permission, fallbackPath = '/' }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate("/dashboard/course", { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainCourses = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.master || {}; // Only using 'master' permissions

  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
        <Route path='/' element={<Courses />} />

        <Route
          path='/add-course'
          element={<ProtectedRoute element={<AddCourses />} permission={Permission.create} fallbackPath="/" />}
        />

        <Route
          path='/view-course'
          element={<ProtectedRoute element={<ViewCourse />} permission={Permission.read} fallbackPath="/" />}
        />

        <Route
          path='/edit-course'
          element={<ProtectedRoute element={<EditCourse />} permission={Permission.update} fallbackPath="/" />}
        />
      </Routes>
    </div>
  );
};

export default MainCourses;
